import { ginzaxiaomaApiRequest } from '.';
import {
  GetCommissionSnapshotItemListParams,
  GetCommissionSnapshotItemListResponse,
  GetCommissionSnapshotListParams,
  GetCommissionSnapshotListResponse,
  ImportCommissionSnapshotResponse,
} from 'types/commission-snapshot';

const BASE_PATH = '/admin/commission-snapshot';

export const getCommissionSnapshotList = (
  params: GetCommissionSnapshotListParams,
) => {
  return ginzaxiaomaApiRequest.get<GetCommissionSnapshotListResponse>(
    `${BASE_PATH}/list`,
    { params },
  );
};

export const getCommissionSnapshotItems = (
  params: GetCommissionSnapshotItemListParams,
) => {
  return ginzaxiaomaApiRequest.post<GetCommissionSnapshotItemListResponse>(
    `${BASE_PATH}/items`,
    params,
  );
};

export const deleteCommissionSnapshot = (id: number) => {
  return ginzaxiaomaApiRequest.delete<{ success: true }>(`${BASE_PATH}/${id}`);
};

export type ImportCommissionSnapshotDto = {
  file: File;
  name: string;
  remark?: string;
};

export const importCommissionSnapshot = (dto: ImportCommissionSnapshotDto) => {
  const formData = new FormData();
  formData.append('file', dto.file);
  formData.append('name', dto.name);
  if (dto.remark) formData.append('remark', dto.remark);

  return ginzaxiaomaApiRequest.post<ImportCommissionSnapshotResponse>(
    `${BASE_PATH}/import`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
};
